import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tipoEvento'
})
export class TipoEventoPipe implements PipeTransform {

  private eventos: { [key: number]: string } = {

    1: 'administración del sistema',

    2: 'eventos de la UCC',

    3: 'eventos relacionados a los programas informáticos',

    4: 'eventos de comunicación',

    5: 'operaciones cotidianas',

    6: 'verificaciones realizadas por la autoridad fiscal o por proveedores autorizados por el SAT',

    7: 'exista una diferencia de más de 0.5 % tratándose de Hidrocarburos y Petrolíferos líquidos o de 1 % tratándose de Hidrocarburos y Petrolíferos gaseosos, en el volumen final del periodo, obtenido de sumar al volumen inicial en dicho periodo, las recepciones de producto y restar las entregas de producto, incluyendo las pérdidas por proceso',

    8: 'el volumen de existencias registrado al corte del día, es igual al registrado en el corte del día anterior y existen registros de entradas o salidas en el corte del día',

    9: 'el volumen de existencias registrado por cada tipo de Hidrocarburo o Petrolífero y sistema de medición es menor a cero',

    10: 'el volumen de existencias registrado en el corte del día varía con respecto al corte del día anterior y no existen registros de entradas o salidas en el corte del día',

    11: 'el volumen de salidas en un lapso de veinticuatro horas es mayor al volumen de entradas del mismo lapso más el volumen de existencias del corte del día anterior',

    12: 'calibración no vigente',

    13: 'intento de alteración de cualquier registro',

    14: 'registros incompletos o duplicados',

    15: 'problemas de comunicación',

    16: 'falla del medio de almacenamiento',

    17: 'falla en la red de comunicación',

    18: 'falla de energía',

    19: 'error en la transmisión de información',

    20: 'rechazos de inicio de sesión',

    21: 'paro de emergencia'

  };

  transform(id: number | string): string {

    const tipoId = Number(id);

    return this.eventos[tipoId] || 'Tipo de evento no encontrado';
  }

}